export const BETWEEN_VALUE_DELIMITER = '..'

export interface BetweenBounds {
  min: string
  max: string
}

export const parseBetweenBounds = (value: string): BetweenBounds => {
  if (!value) return { min: '', max: '' }

  const delimiter = value.includes('..')
    ? '..'
    : value.includes(',')
      ? ','
      : value.includes('|')
        ? '|'
        : null
  if (!delimiter) return { min: value, max: '' }

  const [min, max] = value.split(delimiter)
  return { min: min?.trim() ?? '', max: max?.trim() ?? '' }
}

export const formatBetweenBounds = (min: string, max: string): string => {
  if (!min && !max) return ''
  return `${min}${BETWEEN_VALUE_DELIMITER}${max}`
}

// A Between rule is valid only when both bounds are numeric and min <= max.
// Empty bounds are treated as "not yet filled" (not an explicit min > max error).
export const isValidBetweenBounds = (min: string, max: string): boolean => {
  if (min.trim() === '' || max.trim() === '') return true
  const minBound = parseFloat(min)
  const maxBound = parseFloat(max)
  if (Number.isNaN(minBound) || Number.isNaN(maxBound)) return false
  return minBound <= maxBound
}

/** Mirrors AcceptableValueEvaluator#numeric_range_bounds for client-side range checks. */
export const parseNumericRangeBounds = (spec: string): [number, number] | null => {
  if (!spec) return null

  let minSegment: string
  let maxSegment: string

  if (spec.includes('..')) {
    ;[minSegment, maxSegment] = spec.split('..', 2)
  } else if (spec.includes(',')) {
    ;[minSegment, maxSegment] = spec.split(',', 2)
  } else if (spec.includes('|')) {
    ;[minSegment, maxSegment] = spec.split('|', 2)
  } else {
    return null
  }

  const minBound = parseFloat(minSegment.trim())
  const maxBound = parseFloat(maxSegment.trim())
  if (Number.isNaN(minBound) || Number.isNaN(maxBound)) return null

  return [minBound, maxBound]
}
